import { render, staticRenderFns } from "./group-timetable-item.vue?vue&type=template&id=36e182f2&scoped=true&lang=pug&"
import script from "./group-timetable-item.vue?vue&type=script&lang=js&"
export * from "./group-timetable-item.vue?vue&type=script&lang=js&"
import style0 from "./group-timetable-item.vue?vue&type=style&index=0&id=36e182f2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e182f2",
  null
  
)

export default component.exports